import React from "react";
import { Breakpoint } from "@mui/material/styles";
import { Dialog } from "@mui/material";

export interface ModalPropsType {
  sx: any;
  size: Breakpoint;
  openModal: boolean;
  fullWidth: boolean;
  handleModal: () => void;
  children: React.ReactNode;
}

export default function ModalContainer({
    sx,
    size = "sm",
    openModal,
    fullWidth = false,
    handleModal,
    children,
  }: ModalPropsType) {
    return (
      <React.Fragment>
        <Dialog
          fullWidth={fullWidth}
          sx={{ borderRadius: "20px", ...sx }}
          maxWidth={size}
          open={openModal}
          scroll="paper"
          onClose={handleModal}
        >
          {children}
        </Dialog>
      </React.Fragment>
    );
  }